<template>
<div id="enroll-layout">
  <div id="enroll-main">
    <img src="/static/enroll-back.png" alt="">
    <div class="city">—— 中国 · 深圳 ——</div>
    <div class="enroll">
      <div class="enroll-company">上市公司管理层报名</div>
    </div>
    <div class="info" v-text="">
      <h4 class="info-title">峰会简介</h4>
      <p>
        本次峰会旨在充分发挥格隆汇港股资讯及投研第一平台的影响力，
        我们共聚深圳，举办2018格隆汇“高屋建瓴”房地产高峰论坛，
        为更好的发挥资本市场的作用，主办方拟邀请想搞交易所、
        知名地界大咖、优秀房地产上市企业领导、券商代表、各地投资者等，
        共商2018房地产行业趋势及投资策略，同时为优秀的公司提供一
        个与投资者面对面路演交流的平台。
      </p>
      <h4 class="mini">峰会规模</h4>
      <p>500人左右</p>
      <h4 class="mini">活动形式</h4>
        <p>
          Part 1：上午主会场8:30-12:00演讲及圆桌论坛
        </p>
        <p>
          Part 2：下午分论坛13:30-16:40上市公司路演          
        </p>
      <h4 class="mini">活动时间</h4>
      <p>2018年4月20日（周五）</p>
    </div>
    <div class="data-form">
      <label for="company">上市公司名称
        <span class="data-form-required"> * </span>
      </label>
      <input type="text" v-model='form.company' class="input"/>
      <label for="stockCode">公司代码
        <span class="data-form-required"> * </span>
      </label>
      <input type="text" v-model='form.stockCode' class="input"/>
      <label for="person">联系人
        <span class="data-form-required"> * </span>
      </label>
      <input type="text" v-model='form.person' class="input"/>
      <label for="position">联系人职位
        <span class="data-form-required"> * </span>
      </label>
      <input type="text" v-model='form.position' class="input"/>
      <label for="phone">联系人手机
        <span class="data-form-required"> * </span>
      </label>
      <input type="text" v-model.trim="form.phoneNum" class="input"/>
      <p style="color:#fff;font-size:12px;font-weight:100;">*可支持香港手机和大陆手机号</p>
    </div>
    <div class="info">
      <h4 class="mid">格隆汇商务部</h4>
      <p>商务部邮箱：business@gelonghui.com <br>
      商务部联系方式：+0755 8633 2033</p>
      <h4 class="mid">提交须知</h4>
      <p>本次峰会民歌有限，我们将在峰会举办前20个工作日左右，与您确认贵司的报名情况！请认真填写以上资料，谢谢！</p>
    </div>
    <div class="put">
      <input type="button" value="提交" @click="submitData">
    </div>
  </div>
</div>
</template>
<script>
import { Toast, Indicator, MessageBox } from "mint-ui";
export default {
  data() {
    return {
      form: {
        company: "",
        stockCode: "",
        person: "",
        position: "",
        phoneNum: "",
        acid: "1"
      }
    };
  },
  methods: {
    submitData() {
      for (let key in this.form) {
        if (!this.form[key] === true) {
          Toast({
            message: "报名信息不全~",
            iconClass: "icon el-icon-warning"
          });
          return false;
        }
      }
      if (this.form.phoneNum.length !== 11 && this.form.phoneNum.length !== 8) {
        Toast({
          message: "请输入8位香港手机号,或者11位大陆手机号~",
          iconClass: "icon el-icon-warning"
        });
        return false;
      }
      this.putCompanyInfo();
    },
    putCompanyInfo() {
      this.$http.estateforum_create_company_info({ ...this.form }).then(res => {
        if (res.data.statusCode === 200) {
          Toast({
            message: "已报名成功!请留意后续资料审核通知",
            iconClass: "icon el-icon-success",
            duration: 5000
          });
        } else {
          Toast({
            message: '报名失败，请检查网络，或联系我公司。',
            iconClass: "icon el-icon-warning",
            duration: 5000
          });
        }
      });
    }
  }
};
</script>

<style scoped>
#enroll-layout {
  width: 100%;
  background-color: #1e2a57;
}
#enroll-main {
  /* background-color: #1e2a57; */
  background: linear-gradient(47deg, #1e2a59 62%, #433f9f 83%);
  height: 100%;
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}
@media (max-width: 640px) {
  #enroll-main {
    background: linear-gradient(44deg, #1e2a59 77%, #433f9f 88%);
  }
}
.city {
  color: #fff;
  text-align: center;
  margin-top: -30px;
  font-size: 14px;
}
#enroll-main img {
  width: 100%;
}
.enroll {
  padding: 0 40px;
  display: flex;
  justify-content: space-around;
}
.enroll-company {
  margin-top: 20px;
  color: #fff;
  text-decoration: none;
  font-size: 18px;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  background-color: rgb(72, 69, 153);
}
.enroll-person {
  background-color: rgb(43, 103, 177);
}
.info {
  color: #fff;
  padding: 10px;
  padding-left: 20px;
  padding-right: 20px;
}
.info h4 {
  font-size: 16px;
  font-weight: 400;
  padding-bottom: 10px;
  border-bottom: 2px solid #fff;
  padding-top: 20px;
}
.info p {
  padding: 10px;
  padding-left: 0;
  padding-bottom: 0;
  font-size: 12px;
  font-weight: 100;
  line-height: 1.8em;
}
.info .mini {
  width: 68px;
}
.info .mid {
  width: 250px;
}
.data-form {
  padding: 0 20px;
}
.data-form-required {
  color: #fff;
}
.data-form label {
  color: #fff;
  margin: 5px 0;
  display: block;
  font-weight: 200;
  font-size: 14px;
}
.input {
  border-radius: 8px;
  height: 25px;
  font-size: 14px;
  color: #fff;
  background-color: rgb(30, 42, 89);
  border: 1px solid #fff;
  padding: 2px 8px;
  width: 200px;
  outline: none;
}
.put {
  display: flex;
  justify-content: center;
  padding: 20px;
}
.put input {
  background-color: #c8694a;
  border: none;
  padding: 5px 30px;
  padding-bottom: 8px;
  color: #fff;
  font-size: 25px;
  font-weight: 800;
  border-radius: 10px;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/frontend/estateforum/estateforum-company.vue